export default {
  nav: {
    categories: 'Catégories',
    topSites: 'Meilleurs sites',
    compare: 'Comparer',
    submitSite: 'Soumettre un site',
    about: 'À propos',
    logIn: 'Connexion',
  },
  common: {
    back: 'Retour',
    search: 'Rechercher',
    loading: 'Chargement…',
    viewSimilarSites: 'Voir des sites similaires',
  },
  hero: {
    badge: 'Moteur de découverte de sites',
    titleA: 'Trouvez des sites similaires à',
    titleB: 'vos favoris.',
    titlePrefix: 'Trouvez des sites similaires à',
    titleAccent: 'vos favoris.',
    subtitle: 'Découvrez des concurrents, des alternatives et des pépites du web grâce à des scores de similarité précis.',
    placeholder: 'Entrez un domaine (ex. stripe.com)',
    inputPlaceholder: 'Entrez un domaine (ex. stripe.com)',
    step1Label: 'Saisir un domaine',
    step1Desc: 'Tapez une URL de site web pour commencer',
    step2Label: 'Obtenir des résultats',
    step2Desc: 'Notre moteur trouve des sites similaires instantanément',
    step3Label: 'Comparer & décider',
    step3Desc: 'Analysez et comparez les alternatives',
    steps: {
      step1Label: 'Saisir un domaine',
      step1Desc: 'Tapez une URL de site web pour commencer',
      step2Label: 'Obtenir des résultats',
      step2Desc: 'Notre moteur trouve des sites similaires instantanément',
      step3Label: 'Comparer & décider',
      step3Desc: 'Analysez et comparez les alternatives',
    },
  },
  footer: {
    newsletterTitle: 'Restez informé',
    newsletterDesc: 'Recevez chaque semaine des rapports sur les sites tendances et de nouvelles alternatives.',
    emailPlaceholder: 'votre@email.com',
    subscribe: "S'abonner",
    brandDesc: 'Découvrez les connexions cachées du web. Trouvez des sites similaires à vos favoris avec un scoring précis.',
    explore: 'Explorer',
    popular: 'Populaire',
    company: 'Entreprise',
    compareSites: 'Comparer des sites',
    sitesLike: 'Sites comme',
    contact: 'Contact',
    faq: 'FAQ',
    removeYourSite: 'Supprimer votre site',
    privacyPolicy: 'Politique de confidentialité',
    termsOfService: "Conditions d'utilisation",
    rights: 'Tous droits réservés.',
  },
  notFound: {
    title: 'Oups ! Page introuvable',
    returnHome: "Retour à l'accueil",
  },
  submitPage: {
    ctaTitle: 'Vous connaissez un super site ?',
    ctaDesc: 'Enrichissez notre base en soumettant vos sites préférés. Quelques secondes suffisent.',
    ctaButton: 'Soumettre un site',
    pageTitle: 'Soumettre un site',
    pageSubtitle: 'Aidez-nous à enrichir notre base en soumettant un site à indexer.',
    successTitle: 'Site soumis !',
    successReviewPrefix: 'Nous examinerons',
    successReviewSuffix: "et l'ajouterons à notre index sous peu.",
    backHome: "Retour à l'accueil",
    domainLabel: 'Domaine *',
    domainPlaceholder: 'ex. example.com',
    descriptionLabel: 'Description',
    descriptionPlaceholder: 'Brève description du site',
    categoryLabel: 'Catégorie',
    categorySelect: 'Choisir une catégorie',
    alternativeTo: 'Alternative à (optionnel)',
    alternativeNone: 'Aucune — pas une alternative',
    emailLabel: 'Votre e-mail',
    emailPlaceholder: 'vous@exemple.com',
    submitButton: 'Envoyer le site',
    submitFailed: "Échec de l'envoi",
    seoTitle: 'Soumettre un site | CiteMatch',
    seoDesc: 'Soumettez un site pour indexation sur CiteMatch.',
  },
};

